import { action } from 'satcheljs';

/**
 * Action triggered when the accessibility checker button
 * is clicked in the compose form
 */
export default action('onOpenAccessibilityChecker');
